// extracted by mini-css-extract-plugin
export default {"badge":"FeaturesPopup_badge__3sjBP","wrapper":"FeaturesPopup_wrapper__BbUSF"};